import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShineMigrationResponse } from '@shared/interfaces/shine-migration.interface';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root',
})
export class ShineMigrationService {
  public constructor(
    private readonly httpClient: HttpClient,
    private readonly configService: ConfigurationService,
  ) {}

  public getShineMigration(domainId: string): Observable<ShineMigrationResponse> {
    return this.httpClient.get<ShineMigrationResponse>(
      `${this.configService.urlApiSiVision}/api/v2.0/companies/${domainId}/shine-migration`,
    );
  }
}
